<template src="./activitySessionToLectureMapping.html">
</template>
<script>
import SemesterUserRepository from '../../Repository/SemesterUser'
import ShiftRepository from '../../Repository/Shift'
import TimetableRepository from '../../Repository/timetable'
import LecturesRepository from '../../Repository/lectures'
import SessionRepository from '../../Repository/Session'
import SyllabusRepository from '../../Repository/Syllabus'
import UploadToDigitalOcean from '../../Repository/UploadToDigitalOcean'
import InfrastructureReferenceRepository from '../../Repository/InfrastructureReference'
import { createExcelThroughJson } from '../../utils/excel'
import showStatus from '../../NetworkManager/showStatus'
import TimePicker from "../../Components/styleGuide/InputsAndControls/TimePicker.vue";
import DateTimePicker from "../../Components/styleGuide/InputsAndControls/DateTimePicker.vue";

export default {
    name: "activitySessionToLectureMapping",
    props: ['prop_subject', 'prop_type', 'prop_groupInfo'],
    components: {
        TimePicker, DateTimePicker
    },
    data() {
        return {
            loading: false,
            userData: {},
            selectedInstitute: {},
            selectedSemester: {},
            syllabus: {},
            sessions: [],
            sessionLength: 0,
            totalSessions: 0,
            subjectsMapping: {},
            headers: [
                { text: 'Session Number', value: 'sessionNumber' },
                { text: 'Session Type', value: 'sessionType' },
                { text: 'Unit', value: 'unit', width: '150px' },
                { text: 'Topic', value: 'topic', width: '150px' },
                { text: 'Sub Topic', value: 'subTopic', width: '150px' },
                { text: 'Planned Date', value: 'plannedDate', width: '500px' },
                // { text: 'Planned Date', value: 'plannedDateLocal', width: '250px' },
                // { text: 'Planned Time', value: 'plannedTime', width: '250px' },
                // { text: 'test', value: 'time', width: '350px' },
                { text: 'Actual date and time (Attach Lecture)', value: 'lectureDetails', width: '550px' },
                { text: 'Actual Topic Covered', value: 'topicCovered', width: '200px' },
                { text: 'Reference link', value: 'refMaterial', width: '350px' },
                { text: 'Reference File', value: 'refMaterialFile', width: '350px' },
                { text: 'Assessment of conceptual understanding', value: 'learningOfLecture', width: '350px' },
                { text: 'Remarks', value: 'remark', width: '350px' }

            ],
            tableData: [],
            lectureArray: [],
            facultySemDetails: {},
            otherSession: [],
            subTopicDetails: [],
            semUserDetails: {},
            dateTimeObj: {}
        }
    },
    async created() {
        this.semesterRepositoryInstance = new SemesterUserRepository(this)
        this.uploadToDigitalOceanInstance = new UploadToDigitalOcean(this)
        this.shiftRepositoryInstance = new ShiftRepository(this)
        this.timetableRepositoryInstance = new TimetableRepository(this)
        this.lecturesRepositoryInstance = new LecturesRepository(this)
        this.infrastructureReferenceRepositoryInstance = new InfrastructureReferenceRepository(this)
        this.syllabusInstance = new SyllabusRepository(this);
        this.sessionInstance = new SessionRepository(this);
        this.subjectsMapping = this.$store.getters['mappings/get_subjectsMapping']
        this.selectedInstitute = this.$store.getters['instituteData/get_selectedInstitute']
        this.selectedSemester = this.$store.getters['instituteData/get_selectedSemester']
        this.$store.commit('liveData/set_selectedActivityName', 'Session planning')
        this.userData = this.$store.getters['user/get_userData']
        await this.fetchData()
    },
    methods: {
        transformedValue(time) {
            if (!time) return "";
            try {
                const date = new Date(time);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                let hours = date.getHours();
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const period = hours >= 12 ? "PM" : "AM";
                hours = hours % 12 || 12;
                return `${day}-${month}-${year} ${String(hours).padStart(2, '0')}:${minutes} ${period}`;
            } catch {
                return "";
            }
        },
        // start point
        async fetchData() {
            this.loading = true
            try {
                await this.getLectures();
                await this.getFacultySessionPlan();
                await this.getSyllabus();
                await this.getSessions();
                const mainSessionData = this.generateDataTableRows(this.sessions, this.syllabus);
                const finalTableData = this.matchSavedDataWithSessionData(mainSessionData)

                this.tableData = this.addLectureDetailsToTableData(finalTableData)

                this.loading = false
            } catch (error) {
                this.loading = false
            }
        },
        filterOutSessionDetails() {
            this.otherSession = []
            this.savedSessions = []
            if (this.facultySemDetails.sessionPlanForFaculty && this.facultySemDetails.sessionPlanForFaculty.length > 0) {
                this.facultySemDetails.sessionPlanForFaculty.forEach(session => {
                    session.plannedTime = session.plannedDate
                    if (session.subjectId !== this.prop_subject.subjectId) {
                        this.otherSession.push(session)
                    } else {
                        if (this.prop_type === "Division") {
                            if (session.division === this.prop_subject.division) {
                                this.savedSessions.push(session)
                            } else {
                                this.otherSession.push(session)
                            }
                        }
                        if (this.prop_type === "Batch") {
                            if (session.division === this.prop_subject.division && session.batch === this.prop_subject.batch) {
                                this.savedSessions.push(session)
                            } else {
                                this.otherSession.push(session)
                            }
                        }
                        if (this.prop_type === "Group") {
                            if (session.groupId === this.prop_groupInfo.groupId) {
                                this.savedSessions.push(session)
                            } else {
                                this.otherSession.push(session)
                            }
                        }
                    }
                });
            }
        },
        generateDataTableRows(sessions, syllabus) {
            this.subTopicDetails = []
            const unitMap = new Map();

            // Build a nested map structure for easy lookup
            syllabus.units.forEach(unit => {
                const topicMap = new Map();
                unit.topics.forEach(topic => {
                    const subTopicMap = new Map();
                    topic.subTopics.forEach(sub => {
                        subTopicMap.set(sub.subTopicId, sub.subTopicName);
                    });
                    topicMap.set(topic.topicId, {
                        topicName: topic.topicName,
                        subTopics: subTopicMap
                    });
                });

                unitMap.set(unit.unitId, {
                    unitName: unit.unitName,
                    topics: topicMap
                });
            });

            // Create the rows for v-data-table
            return sessions.map(session => {
                const unitDetails = [];
                const unitIds = new Set();
                const topicIds = new Set();
                const subTopicIds = new Set();
                const unitNames = new Set();
                const topicNames = new Set();
                const subTopicNames = new Set();

                session.units.forEach(unit => {
                    const unitInfo = unitMap.get(unit.unitId);
                    if (unitInfo) {
                        unitIds.add(unit.unitId);
                        unitNames.add(unitInfo.unitName);

                        unit.topics.forEach(topic => {
                            const topicInfo = unitInfo.topics.get(topic.topicId);
                            if (topicInfo) {
                                topicIds.add(topic.topicId);
                                topicNames.add(topicInfo.topicName);

                                topic.subTopics.forEach(sub => {
                                    const subTopicName = topicInfo.subTopics.get(sub.subTopicId) || 'N/A';
                                    subTopicIds.add(sub.subTopicId);
                                    subTopicNames.add(subTopicName);
                                    this.subTopicDetails.push({
                                        subTopic: `${unitInfo.unitName}_${topicInfo.topicName}_${subTopicName}`,
                                        subTopicId: sub.subTopicId
                                    })
                                    unitDetails.push({
                                        unitName: unitInfo.unitName,
                                        topicName: topicInfo.topicName,
                                        subTopicName
                                    });
                                });
                            }
                        });
                    }
                });

                return {
                    sessionNumber: session.sessionNumber,
                    plannedDate: '',
                    plannedTime: '',
                    menu: false,
                    id: session.sessionId,
                    sessionType: session.sessionType,
                    sessionLength: session.sessionLength,
                    totalTeachingHours: session.totalTeachingHours,
                    unit: unitDetails[0]?.unitName || '',
                    topic: unitDetails.map(
                        d => `${d.topicName}`
                    ).join(' | '),
                    subTopic: unitDetails.map(
                        d => `${d.subTopicName}`
                    ).join(' | '),
                    unitDetails: unitDetails.map(
                        d => `Unit: ${d.unitName}, Topic: ${d.topicName}, Subtopic: ${d.subTopicName}`
                    ).join(' | '),
                    unitIds: Array.from(unitIds),
                    topicIds: Array.from(topicIds),
                    subTopicIds: Array.from(subTopicIds),
                    unitNames: Array.from(unitNames),
                    topicNames: Array.from(topicNames),
                    subTopicNames: Array.from(subTopicNames),
                    lectureDetails: {
                        lectureId: ''
                    }
                };
            });
        },

        matchSavedDataWithSessionData(tableData) {
            const finalTableData = []
            if (this.savedSessions.length > 0 && tableData.length > 0) {
                tableData.forEach((data, i) => {
                    let flagToCheckSessionPresentOrNot = false
                    this.savedSessions.forEach(savedSession => {
                        if (data.id === savedSession.sessionId) {
                            flagToCheckSessionPresentOrNot = true
                            savedSession.sessionNumber = data.sessionNumber
                            savedSession.id = data.id
                            savedSession.plannedDateLocal = savedSession.plannedDate !== '' ? this.convertUTCToLocal(savedSession.plannedDate) : ''
                            savedSession.unitDetails = data.unitDetails
                            savedSession.plannedDate = `Date:- ${this.formatDateToCustomString(savedSession.plannedDate)} | Time:- ${this.convertUTCtoLocalTimeWithAMPM(savedSession.plannedDate)}`
                            savedSession.unit = data.unit
                            savedSession.topic = data.topic
                            savedSession.subTopic = data.subTopic
                            savedSession.sessionType = data.sessionType
                            savedSession.totalTeachingHours = data.totalTeachingHours
                            savedSession.sessionLength = data.sessionLength
                            savedSession.subTopicIds = data.subTopicIds
                            // savedSession.topicString = `${data.unit}_${data.topic}_${data.subTopic}`
                            savedSession.lectureDetails = {
                                lectureId: ''
                            }
                            finalTableData.push(savedSession)
                        }
                    });
                    if (flagToCheckSessionPresentOrNot === false) {
                        finalTableData.push(data)
                    }
                });
                return finalTableData
            } else {
                return tableData
            }
        },
        downloadFiles(fileArray) {
            fileArray.forEach(file => {
    window.open(file.url, '_blank');
  });
        },
        addLectureDetailsToTableData(tableData) {
            if (this.lectureArray.length > 0) {
                this.lectureArray.forEach((data, i) => {
                    if (tableData.length > 0) {
                        tableData.forEach((session, j) => {
                            if (session.id === data.sessionId) {
                                session.isCoveredDatePresent = true
                                session.lectureDetails = data
                                session.refMaterial = data.refMaterial ? data.refMaterial : ''
                                session.refMaterialFile = data.refMaterialFile ? data.refMaterialFile : []
                                session.learningOfLecture = data.learningOfLecture ? data.learningOfLecture : ''
                                session.remark = data.remarksForLecture ? data.remarksForLecture[0] : ''
                                session.topicCovered = []
                                const idsArr = []
                                if (this.subTopicDetails.length > 0 && data.coveredTopicIds.length > 0) {
                                    this.subTopicDetails.forEach((sub) => {
                                        data.coveredTopicIds.forEach((ids) => {
                                            if (sub.subTopicId === ids) {
                                                if (!idsArr.includes(sub.subTopicId)) {
                                                    idsArr.push(sub.subTopicId)
                                                    session.topicCovered.push(sub)
                                                }
                                            }
                                        })
                                    })
                                }
                            }
                            if (i === j) {
                                if (session.plannedTime === undefined || session.plannedTime === '') {
                                    session.plannedDate = data.startTime
                                }
                            }
                        });
                    }
                });
            }
            return tableData
        },
        plannedDateChanged(session, i) {
            session.isChanged = true
            this.$set(this.tableData, i, session);
        },
        // normal functions
        assignedLectureChanged(value, session, i) {
            if (value !== null) {
                session.isChanged = true
                const data = session.lectureDetails
                session.refMaterial = data.refMaterial ? data.refMaterial : ''
                session.refMaterialFile = data.refMaterialFile ? data.refMaterialFile : []
                session.learningOfLecture = data.learningOfLecture ? data.learningOfLecture : ''
                session.remark = data.remarksForLecture ? data.remarksForLecture[0] : ''
                session.topicCovered = data.topicCovered ? data.topicCovered : ''
                session.isCoveredDatePresent = true
                this.$set(this.tableData, i, session);
            }
        },
        downloadReport() {
            const arrForExcel = []
            if (this.tableData.length > 0) {
                this.tableData.forEach(data => {
                    let url = ''
                    if (data.refMaterialFile && data.refMaterialFile.length > 0) {
                        url = data.refMaterialFile.map(file => file.url).join(', ');
                    }
                    arrForExcel.push({
                        'Session Number': data.sessionNumber,
                        'Session Type': data.sessionType,
                        'Unit': data.unit ? data.unit : '',
                        'Topic': data.topic ? data.topic : '',
                        'Sub Topic': data.subTopic ? data.subTopic : '',
                        'Planned Date': data.plannedDate && data.plannedDate !== '' ? this.convertUTCToLocal(data.plannedDate) : '',
                        'Planned Time': data.plannedDate && data.plannedDate !== '' ? this.convertUTCtoLocalTimeWithAMPM(data.plannedTime) : '',
                        'Actual Date': data.lectureDetails.dateTime ? this.convertUTCToLocal(data.lectureDetails.dateTime) : '',
                        'Actual Time': data.lectureDetails.startTime ? `${this.convertUTCtoLocalTimeWithAMPM(data.lectureDetails.startTime)}- ${this.convertUTCtoLocalTimeWithAMPM(data.lectureDetails.endTime)}` : '',
                        'Actual Topic Covered': data.topicCovered ? data.topicCovered : '',
                        'Reference Material': data.refMaterial ? data.refMaterial : '',
                        'Assessment of conceptual understanding': data.learningOfLecture ? data.learningOfLecture : '',
                        "Remark": data.remark ? data.remark : '',
                        "Attachment": url
                    })
                });
            }
            createExcelThroughJson(arrForExcel, `Session Planning Report for ${this.prop_subject.subjectName}`)
        },
        clearLectureDetails(session, i) {
            session.isChanged = false
            session.lectureDetails = {
                lectureId: ''
            }
            session.refMaterial = ''
            session.learningOfLecture = ''
            session.remark = ''
            session.topicCovered = ''
            this.$set(this.tableData, i, session);
        },
        async saveSessionDetails() {
            const arrayToAttach = [...this.otherSession]
            let flag = false
            if (this.tableData.length > 0) {
                this.tableData.forEach(session => {
                    if ((session?.lectureDetails?.lectureId !== '' && session?.lectureDetails !== null && session?.lectureDetails?.lectureId !== undefined) && session.plannedDate === '') {
                        flag = true
                    }
                })
                if (flag === true) {
                    showStatus('Please fill all the details', 3000, 'error', this)
                    return
                }

                this.tableData.forEach(session => {
                    if (session.plannedDate !== '') {
                        const obj = {
                            sessionId: session.id,
                            subjectId: this.prop_subject.subjectId,
                            plannedDate: this.dateTimeObj[session.plannedDate],
                            division: '',
                            batch: '',
                            groupId: ''
                        }
                        if (this.prop_type === "Division") {
                            obj.division = this.prop_subject.division
                        }
                        if (this.prop_type === "Batch") {
                            obj.division = this.prop_subject.division
                            obj.batch = this.prop_subject.batch
                        }
                        if (this.prop_type === "Group") {
                            obj.groupId = this.prop_groupInfo.groupId
                        }
                        arrayToAttach.push(obj)
                    }
                });
            }
            const lecUpdateArr = await this.updateLecture()
            await this.updateLectureDetails(lecUpdateArr)
            await this.updateSemUser([{
                uId: this.userData.uId,
                semId: this.selectedSemester.semId,
                instituteId: this.selectedInstitute,
                sessionPlanForFaculty: arrayToAttach
            }])
        },
        fileChanged(item) {
            item['isChangedFile'] = true
        },
        async uploadFiles() {
            if (this.tableData.length > 0) {
                for (const session of this.tableData) {
                    if (session.refMaterialFile && session.isChangedFile === true) {
                        session.uploadFileDetails = await this.uploadToDigitalOceanInstance.upload([session.refMaterialFile], this.userData.uId);
                    } else {
                        session.uploadFileDetails = session.refMaterialFile
                    }
                }
            }
        },
        async updateLecture() {
            const lectureToUpdate = []
            await this.uploadFiles()

            if (this.lectureArray.length > 0 && this.tableData.length > 0) {
                this.lectureArray.forEach((data) => {
                    let flagForLecturePresent = false
                    this.tableData.forEach((session) => {
                        if (session?.lectureDetails?.lectureId === data.lectureId) {
                            flagForLecturePresent = true
                            const obj = {
                                lectureId: data.lectureId,
                                instituteId: this.selectedInstitute,
                                semId: this.selectedSemester.semId,
                                sessionId: session.id,
                                plannedTopicIds: session.subTopicIds,
                                refMaterial: session.refMaterial,
                                refMaterialFile: [],
                                learningOfLecture: session.learningOfLecture,
                                coveredTopicIds: [],
                                remarksForLecture: session.remark ? session.remark : ''
                            }
                            if (session.uploadFileDetails) {
                                obj.refMaterialFile = session.uploadFileDetails
                            }
                            if (session.topicCovered.length > 0) {
                                obj.coveredTopicIds = session.topicCovered.map((subTopic) => subTopic.subTopicId)
                                obj.coveredTopicIds = [...new Set(obj.coveredTopicIds)]
                            }
                            lectureToUpdate.push(obj)
                        }
                    });
                    if (flagForLecturePresent === false) {
                        lectureToUpdate.push({
                            lectureId: data.lectureId,
                            instituteId: this.selectedInstitute,
                            semId: this.selectedSemester.semId,
                            sessionId: '',
                            plannedTopicIds: []
                        })
                    }
                });
            }
            return lectureToUpdate
        },

        dateChangedForBulkEdit(data, i) {
            data.menu = true
            this.$set(this.tableData, i, data);
        },
        closeDateForEditBulk(data, i) {
            data.menu = false
            this.$set(this.tableData, i, data);
        },

        // common function
        handleGoBack() {
            history.back()
        },

        convertUTCtoLocalTimeWithAMPM(utcDateString) {
            const utcDate = new Date(utcDateString);
            const hours = utcDate.getHours();
            const minutes = utcDate.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;
            const result = formattedHours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + ampm;
            return result;
        },
        formatDateToCustomString(isoDateString) {
            const date = new Date(isoDateString);
            const day = date.getDate();
            const monthNames = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear().toString().slice(-2); // Get last 2 digits of year

            return `${day} ${month} ${year}`;
        },

        convertToUTC(dateString, timeString) {
            // Combine date and time into a single string
            const dateTimeString = `${dateString} ${timeString}`;

            // Parse using the local time zone
            const localDate = new Date(dateTimeString);

            // Return ISO string in UTC format
            return localDate.toISOString();
        },
        convertUTCToLocal(utcString) {
            const date = new Date(utcString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`; // e.g., "2025-03-22"
        },

        // api calls
        async getLectures() {
            try {
                const res = await this.lecturesRepositoryInstance.getLecturesOfAFacultyOfASubject({
                    instituteId: this.selectedInstitute,
                    semId: this.selectedSemester.semId,
                    department: this.prop_subject.department,
                    courseYear: this.prop_subject.courseYear,
                    subjectId: this.prop_subject.subjectId,
                    uId: this.userData.uId
                })
                this.lectureArray = []
                if (res && res.length > 0) {
                    res.forEach(lecture => {
                        if ((lecture.present.length > 0 || lecture.absent.length > 0 || new Date(lecture.startTime) > new Date()) && lecture.status !== 6) {
                            lecture.nameToDisplay = `Date:- ${this.formatDateToCustomString(lecture.dateTime)} | Time:- ${this.convertUTCtoLocalTimeWithAMPM(lecture.startTime)} - ${this.convertUTCtoLocalTimeWithAMPM(lecture.endTime)}`
                            lecture.dateString = `Date:- ${this.formatDateToCustomString(lecture.dateTime)} | Time:- ${this.convertUTCtoLocalTimeWithAMPM(lecture.dateTime)}`
                            this.dateTimeObj[lecture.dateString] = lecture.dateTime
                            if (this.prop_type === "Division") {
                                if (lecture.division === this.prop_subject.division && (lecture.batch === '' || lecture.batch === undefined)) {
                                    this.lectureArray.push(lecture)
                                }
                            }
                            if (this.prop_type === "Batch") {
                                if (lecture.batch === this.prop_subject.batch && lecture.division === this.prop_subject.division) {
                                    this.lectureArray.push(lecture)
                                }
                            }
                            if (this.prop_type === "Group") {
                                if (Array.isArray(lecture.groupForSubject) && lecture.groupForSubject.length > 0) {
                                    if (lecture.groupForSubject[0].groupId === this.prop_groupInfo.groupId) {
                                        this.lectureArray.push(lecture)
                                    }
                                }
                            }
                        }
                    });
                };
            } catch (error) {
                console.error(error)
            }
        },
        async getFacultySessionPlan() {
            try {
                const res = await this.semesterRepositoryInstance.getSemUserDetails({
                    instituteId: this.selectedInstitute,
                    semId: this.selectedSemester.semId,
                    uId: this.userData.uId
                })
                this.facultySemDetails = res
                this.filterOutSessionDetails()
            } catch (error) {
                console.error(error)
            }
        },
        async getSyllabus() {
            const res = await this.syllabusInstance.getSyllabus({
                instituteId: this.selectedInstitute,
                semId: this.selectedSemester.semId,
                department: this.prop_subject.department,
                courseYear: this.prop_subject.courseYear,
                subjectId: this.prop_subject.subjectId
            });
            this.syllabus = res.result ? res.result : {};
        },
        async updateSemUser(arr) {
            try {
                await this.semesterRepositoryInstance.updateSemesterUser({
                    bulkDataArray: arr
                })
                showStatus('Session details saved successfully', 3000, 'success', this)
            } catch (error) {
                console.error('error', error);
                showStatus('Failed to save session details', 3000, 'error', this)
            }
        },
        async updateLectureDetails(arr) {
            try {
                await this.lecturesRepositoryInstance.updateMultipleLectureDocument({
                    bulkDataArray: arr
                })
            } catch (error) {
                console.error('error', error);
            }
        },
        async getSessions() {
            try {
                const res = await this.sessionInstance.getSessions({
                    instituteId: this.selectedInstitute,
                    semId: this.selectedSemester.semId,
                    department: this.prop_subject.department,
                    courseYear: this.prop_subject.courseYear,
                    subjectId: this.prop_subject.subjectId
                })
                this.sessions = res.result ? res.result : [];
            } catch (error) {
                console.error(error)
            }
        }
    }
}

</script>
<style src="./activitySessionToLectureMapping.css"></style>
